import React /*, { useEffect, useState } */ from 'react'
// import api from '../../_services/api'
// import { useParams, useNavigate } from 'react-router-dom'
// import Header from '../../components/HeaderNoMenu'
import { Row, Container/*, Col, Image, Dropdown, DropdownButton */ } from 'react-bootstrap'
// import { padding } from '@mui/system'
import { RechagTV, TextDetails, LabelSelect, Nickname } from './styles'
import { Checkbox } from '@mui/material'
import FormControlLabel from '@mui/material/FormControlLabel'
import Button from '../../components/Button'

export default function RechargeCell () {
  // const label = { inputProps: { 'aria-label': 'Salvar para próximas' } }

  return (
      <>
      <Container>
      {/* <Header onClick={() => navigate(-1)} /> */}
      <RechagTV>Recarga de celular</RechagTV>
      <TextDetails>Recarregue seu celular, com a grana que você já acumulou.</TextDetails>
      <Row>
      <LabelSelect>Recarga recente</LabelSelect>
      <select name="recent-recharge" id="recent-recharge">
        <option value="0">Selecionar a recarga recente</option>
        <option value="1">R$ 5,00</option>
        <option value="1">R$ 10,00</option>
        <option value="2">R$ 15,00</option>
        <option value="3">R$ 20,00</option>
      </select>
      </Row>
      <Row>
      <LabelSelect>Número do celular com DDD</LabelSelect>
      <select name="recent-recharge" id="recent-recharge">
        <option value="0">Selecionar a recarga recente</option>
        <option value="1">(99) 99999.9999</option>
        <option value="2">(88) 88888.8888</option>
        <option value="3">(77) 77777.7777</option>
      </select>
      </Row>
      <Row>
      <LabelSelect>Operadora</LabelSelect>
      <select name="recent-recharge" id="recent-recharge">
        <option value="0">Selecionar a operadora</option>
        <option value="1">OI</option>
        <option value="1">TIM</option>
        <option value="2">VIVO</option>
        <option value="3">CLARO</option>
      </select>
      </Row>
      <Row>
        <FormControlLabel control={<Checkbox defaultChecked />} label="Salvar para próximas recargas." />
      </Row>
      <Row>
          <Nickname type={Text} value="Apelido" />
      </Row>
      <Row>
          <Button>CONTINUAR</Button>
      </Row>
    </Container>
      </>
  )
}
